import { render, staticRenderFns } from "./ManageMatches.vue?vue&type=template&id=9b8a5218&scoped=true&"
import script from "./ManageMatches.vue?vue&type=script&lang=js&"
export * from "./ManageMatches.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b8a5218",
  null
  
)

export default component.exports